// extracted by mini-css-extract-plugin
export default {"footer":"PublicFooter-module__footer--o8N0A","animatedBackground":"PublicFooter-module__animatedBackground--l0t2q"};